export default __webpack_public_path__ + "static/media/manjian.b838b4ef.png";